import { render, staticRenderFns } from "./myBanner.vue?vue&type=template&id=1c94fdb4&scoped=true&"
import script from "./myBanner.vue?vue&type=script&lang=js&"
export * from "./myBanner.vue?vue&type=script&lang=js&"
import style0 from "./myBanner.vue?vue&type=style&index=0&id=1c94fdb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94fdb4",
  null
  
)

export default component.exports